module.exports = __webpack_public_path__ + "static/feature-2-adee4125e6772a49b135114f76ff0695.png";